import { render } from "./sharePage.vue?vue&type=template&id=65b0b636&scoped=true"
import script from "./sharePage.vue?vue&type=script&lang=js"
export * from "./sharePage.vue?vue&type=script&lang=js"

import "./sharePage.vue?vue&type=style&index=0&id=65b0b636&lang=scss&scoped=true"

import exportComponent from "/Users/johnhan/Desktop/project/huitu_activity_fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.32_vue@3.5.32_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b0b636"]])

export default __exports__